import react, {useState} from "react"
import firebase from 'firebase/compat/app';

import { collection, addDoc } from "firebase/firestore"; 

import {app,db} from "./Firebase/firebase"
import { getAuth,GoogleAuthProvider,signInWithRedirect,onAuthStateChanged } from "firebase/auth";
const auth = getAuth(app);

 const Admin= (props)=>{ 

  const[isLoggedin, setisLoggedin] = useState(false)
  
  const provider = new GoogleAuthProvider();
  onAuthStateChanged(auth, (user) => {
    if (user) {
      // User is signed in, see docs for a list of available properties
      // https://firebase.google.com/docs/reference/js/firebase.User
      const uid = user.uid;
    //  console.log(user)
      setisLoggedin(true)
      // ...
    } else {
     
      signInWithRedirect(auth, provider);
    }
  });



  function SignIn() {

    const signInWithGoogle = () => {
      
   }
}
  //console.log(auth)
  if (isLoggedin){
    return(<div>
        
        <AddPost/> 
      </div>
    
      )
  } 
  else{
    return(
      <div>
        You need to log in first
      </div>
    )
  }

}





const AddPost =()=>{
  const [title, setTitle] = useState("");
  const [link, setLink] = useState("");
  const [type, setType] = useState("");

  const submit =async()=>{
    let date = new Date( Date.now())
   const object={
      title,
      link,
      type,
      "addedby": auth.currentUser.email,
      "created" : date.toLocaleDateString('en-US')
    }
    //console.log(object)
    try {
      const docRef = await addDoc(collection(db, "Posts"),object);
      setTitle("")
      setLink("")
      setType("")
    } catch (e) {
      alert("Error adding document");
    }

  }
  return(
    <div className ="container">
<div>
<h2> Add a Post</h2>
     
   

    <div className="input-group mb-2">
      <span className="input-group-text" id="basic-addon1">Title</span><input  value ={title}className="form-control" placeholder="Title" onChange={(e)=>{setTitle(e.target.value)}} />
      </div>
      <div className="input-group mb-2">
      <span className="input-group-text" id="basic-addon1">Post</span><input value={link} className="form-control" placeholder="Link" onChange={(e)=>{setLink(e.target.value)}} />
    </div>
    <div className="input-group mb-2">
    <span className="input-group-text" id="basic-addon1">Type</span>
      <select className="form-control" value={type} onChange={(e)=>{setType(e.target.value)}}>
      <option value =""></option>
        <option value ="Demo">Demostration</option>
        <option value="Guide">Guide</option>
        <option value="Routine">Routine</option>
        <option value="Youtube">Youtube</option>
        <option value = "Hink">Doc Hink</option>
        <option value ="Other">Other</option>
      </select>
    </div>
    <button className="btn btn-primary" on onClick={submit}>Add</button>
    </div>
    </div>
  )
}
    
export default Admin;